import { render, staticRenderFns } from "./ClientesCrisp.vue?vue&type=template&id=2e34188c&scoped=true"
import script from "./ClientesCrisp.vue?vue&type=script&lang=js"
export * from "./ClientesCrisp.vue?vue&type=script&lang=js"
import style0 from "./ClientesCrisp.vue?vue&type=style&index=0&id=2e34188c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34188c",
  null
  
)

export default component.exports